import { render, staticRenderFns } from "./CmgSelect.vue?vue&type=template&id=ea4b7978&scoped=true&lang=pug&"
import script from "./cmg-select.ts?vue&type=script&lang=ts&"
export * from "./cmg-select.ts?vue&type=script&lang=ts&"
import style0 from "./CmgSelect.vue?vue&type=style&index=0&id=ea4b7978&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea4b7978",
  null
  
)

export default component.exports